  import React, { useEffect } from 'react';
  import Banner from '../components/Banner';
  import Services from '../components/Services';
  import { Map } from '../components/Map';
  import Buysell from '../components/Buysell';
  import Values from '../components/Values';
  import { RiMenu3Line } from 'react-icons/ri';
  import Testimonials from '../components/Testimonials';
import Footer from '../components/Footer';

  const Home = ({ toggleMobileMenu }) => {
    const handleMobileMenuClick = () => {
      toggleMobileMenu();
    };

    useEffect(() => {
      window.scrollTo(0, 0); 
    }, []);

    return (
      <div className='relative top-0'>
        
        <div className='overflow-hidden'>
          <button onClick={handleMobileMenuClick}
            className="text-white p-2 focus:outline-none lg:hidden hidden" >
            <RiMenu3Line size={24} />
          </button>
          <div className='flex flex-col gap-y-8'>
          <div className=''>
          <Banner />
          </div>
          <div className=''>
            <Services id="services" toggleMobileMenu={toggleMobileMenu} />
          </div>
          <Buysell toggleMobileMenu={toggleMobileMenu} />
          <div className=''>
            <Values toggleMobileMenu={toggleMobileMenu} />
          </div>
          <div className='map-container'>
            <Map toggleMobileMenu={toggleMobileMenu} />
          </div>
          <div className="">
            <Testimonials toggleMobileMenu={toggleMobileMenu} />
          </div>
          <div className="md:mt-7 mt-2">
          <Footer />  

          </div>
          </div>

        </div>
      </div>
    );
  };

  export default Home;
